import { MapFooter as View } from 'ui-components'

import { useMapNavStore } from '~map-preview/states/mapNav'

export const Footer = () => {
  const { mapAttributionText, infoGraphicOpen, drawerOpen } = useMapNavStore()
  if (infoGraphicOpen && drawerOpen) return null
  if (!mapAttributionText) return null
  return <View mapAttributionText={mapAttributionText} />
}
